import React from 'react';

export function Eyebrow({ children, center = false, className = '', style }) {
  const classes = ['ds-eyebrow', center ? 'ds-eyebrow--center' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
}

export function EyebrowDot({ className = '' }) {
  return <span className={`ds-eyebrow-dot ${className}`.trim()} aria-hidden />;
}

export default Eyebrow;
